import React from 'react'
import HotLayout from 'Components/new/hot/hot-layout'
import ModuleTitle from 'New/auto/series/components/module-title'
import { HotTopicItem } from 'Components/new/hot/hot-item'

interface IProps {
  topicHot?: any
  title?: string
  onClickItem?(params: { id?: string; name?: string }): void
}

const HotTopic: React.FC<IProps> = ({
  title = '热门话题',
  topicHot,
  onClickItem,
}) => {
  return (
    <React.Fragment>
      <HotLayout
        className="hot-talk-wrapper tw-bg-white tw-px-16 tw-mb-12 tw-w-full md:tw-pb-0 tw-pb-12 tw-rounded-2"
        smRows={2}
        smCols={2}
        gap={6}
        slideClass="tw-w-1/2 md:tw-w-full"
        slideCount={topicHot?.hot_list?.length || 0}
        title={
          <div className="tw-py-11 title tw-pl-24">
            <ModuleTitle>{title}</ModuleTitle>
          </div>
        }
      >
        {({ index }) => {
          const item = topicHot?.hot_list[index]

          return (
            <a
              href={`/topic/${item.id_str}`}
              target={'_blank'}
              key={item.id_str}
              onClick={() => {
                if (onClickItem)
                  onClickItem({
                    id: item.id_str,
                    name: item.name,
                  })
              }}
            >
              <HotTopicItem
                index={index}
                name={item.name}
                desc={item.intro}
                joinCount={item.user_count}
                readCount={item.total_play_count}
                coverUrl={item.logo}
              />
            </a>
          )
        }}
      </HotLayout>
      <style jsx>
        {`
          .title {
            background: url(${require('static/group-hot@3x.png')}) left center/
              20px 20px no-repeat;
          }
        `}
      </style>
    </React.Fragment>
  )
}

export default HotTopic
